import React, { useEffect, useState, useRef } from 'react';

const AnimatedNumber = ({ targetValue, suffix = '', duration = 2000, startAnimation }) => {
    const [count, setCount] = useState(0);

    useEffect(() => {
        if (!startAnimation) return; // Only start animation when visible

        let start = 0;
        const increment = targetValue / (duration / 10);

        const timer = setInterval(() => {
            start += increment;
            if (start >= targetValue) {
                setCount(targetValue);
                clearInterval(timer);
            } else {
                setCount(Math.floor(start));
            }
        }, 10);

        return () => clearInterval(timer);
    }, [targetValue, duration, startAnimation]);

    return <span>{count.toLocaleString()}{suffix}</span>;
};

const Section5 = () => {
    const sectionRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.disconnect(); // Stop observing once visible
                }
            },
            { threshold: 0.5 } // Trigger when 50% of the section is visible
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => observer.disconnect();
    }, []);

    return (
        <section className="section-5" ref={sectionRef}>
            <div className='container'>
                <div className='other-row content'>
                    <div className='col col-40'>
                        <h3 className='title'>Discover the Power of Clean Water</h3>
                    </div>
                    <div className='col col-60'>
                        <p className='desc'>
                            Our filtration system removes 99% of contaminants, ensuring your family enjoys safe and healthy water. Join thousands of satisfied customers who trust us for their water needs.
                        </p>
                        <div className='content'>
                            <div className='other-row'>
                                <div className='col col-50'>
                                    <div className='item'>
                                        <h3 className='num'>
                                            <AnimatedNumber targetValue={240} suffix="k" startAnimation={isVisible} />
                                        </h3>
                                        <p className='desc'>There are over 240,000 plastic nano-particles per 1 litre of bottled water!</p>
                                    </div>
                                </div>
                                <div className='col col-50'>
                                    <div className='item'>
                                        <h3 className='num'>
                                            <AnimatedNumber targetValue={96} suffix="+" startAnimation={isVisible} />
                                        </h3>
                                        <p className='desc'>Removed Contaminants</p>
                                    </div>
                                </div>
                            </div>
                            <div className='other-row'>
                                <div className='col col-50'>
                                    <div className='item'>
                                        <h3 className='num'>
                                            <AnimatedNumber targetValue={99} suffix="%" startAnimation={isVisible} />
                                        </h3>
                                        <p className='desc'>Removed up to 99% of Harmful Substances</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Section5;